import type { FormRenderFieldEventInit } from './FormRenderFieldEvent';

import { FormRenderFieldEvent } from './FormRenderFieldEvent';

type FormConfigFieldEventInit = FormRenderFieldEventInit & {
  config: object;
};

/**
 * An event that is fired when a field is rendered in the object form.
 * No result is expected, but event may modify the config object that is then passed to the field.
 * This event is fired for every field in the form except hidden ones.
 *
 * If additionalElements are added to the config, additional elements will be rendered in the field component
 *
 * Use the config.className field to add custom CSS classes.
 * The config object supports passing any standard HTML properties for input and textarea elements —
 * for example config.placeholder = "test" or config.maxLength = 100.
 *
 * @eventName "flotiq.form.field::config"
 * @memberof FlotiqPlugins.Events
 */
export class FormConfigFieldEvent extends FormRenderFieldEvent {
  /** Field configuration */
  readonly config: object;

  constructor(initData: FormConfigFieldEventInit) {
    super(initData);
    this.config = initData.config;
  }
}
